import { Button, Form, Input, Modal, DatePicker } from "antd";

import { isDatePast } from "../../../utils/helper";

const NewBatchFormModal = ({
  isModalOpen = false,
  setIsModalOpen = () => {},
  handleCreateBatch = () => {}
}) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleFormSubmit = (values) => {
    handleCreateBatch(values);
  };

  return (
    <Modal
      title="Create New Batch"
      open={isModalOpen}
      footer={[]}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <Form form={form} name="new_batch_form" onFinish={handleFormSubmit}>
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: "Please enter the batch name!"
            }
          ]}
        >
          <Input
            prefix={<i className="fa fa-ship" aria-hidden="true" />}
            placeholder="Some Awesome Name!"
          />
        </Form.Item>
        <Form.Item
          name="startDate"
          label="Start Date"
          rules={[
            {
              required: true,
              message: "Please select the start date of the batch!"
            }
          ]}
        >
          <DatePicker disabledDate={isDatePast} />
        </Form.Item>
        <Form.Item
          name="endDate"
          label="End Date"
          rules={[
            {
              required: false,
              message: "Please select the end date of the batch!"
            }
          ]}
        >
          <DatePicker disabledDate={isDatePast} />
        </Form.Item>

        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            Create Batch
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default NewBatchFormModal;
